<main class="app-shell">
  <router-outlet />
</main>
